export const cleanOneTrustHtags = () => {
  const banner = document.getElementById('onetrust-pc-sdk')

  if(!banner) return

  const headers = banner?.querySelectorAll('h1, h2, h3, h4, h5, h6')
  const headersArr = Array.from(headers)
  headersArr.forEach(header => header.remove())
}
